<ul class="SideLinks__items">
  @for (item of navItems(); track trackByIndex(item, $index)) {
    <li
      class="SideLinks__item"
      [class.SideLinks__item--active]="item.moduleId && item.moduleId === currentModule()"
      (click)="navigate(item)"
      placement="right"
      [ngbTooltip]="item.label"
      [tabindex]="0"
    >
      @if (item.moduleId === 'data-wizard') {
        @if (extractNotificationService.extractActive() | async) {
          <grid-ui-loading id="loading-icon" class="SideLinks__notification-icon" [message]="''"> </grid-ui-loading>
        } @else if (extractNotificationService.extractCompleteVisible() | async) {
          <grid-ui-icon id="complete-icon" class="SideLinks__notification-icon" name="tick-circle"></grid-ui-icon>
        }
      }
      @switch (item.imageHref) {
        <!-- Here we want the icon color to change when another element is hovered, so we need to use inlineSVGs  -->
        @case ('shape-country-risk') {
          <grid-ui-icon
            class="SideLinks__icon"
            name="country-risk"
            [useInlineSVG]="true"
            data-testid="icon-sidemenu-country-risk"
          ></grid-ui-icon>
        }
        @case ('shape-video') {
          <grid-ui-icon class="SideLinks__icon" name="video" [useInlineSVG]="true" data-testid="icon-sidemenu-learn"></grid-ui-icon>
        }
        @case ('shape-sovereign-esg-ratings') {
          <grid-ui-icon class="SideLinks__icon" name="sovereign" [useInlineSVG]="true" data-testid="icon-sidemenu-sovereign"></grid-ui-icon>
        }
        @case ('shape-commodity-risk') {
          <grid-ui-icon
            class="SideLinks__icon"
            name="commodity-risk"
            [useInlineSVG]="true"
            data-testid="icon-sidemenu-commodity-risk"
          ></grid-ui-icon>
        }
        @case ('shape-industry-risk') {
          <grid-ui-icon
            class="SideLinks__icon"
            name="industry-chart"
            [useInlineSVG]="true"
            data-testid="icon-sidemenu-industry-risk"
          ></grid-ui-icon>
        }
        @case ('shape-corporate-exposure') {
          <grid-ui-icon
            class="SideLinks__icon"
            name="corporate-exposure"
            [useInlineSVG]="true"
            data-testid="icon-sidemenu-corporate-exposure"
          ></grid-ui-icon>
        }
        @case ('shape-data-wizard') {
          <grid-ui-icon
            class="SideLinks__icon"
            name="data-wizard"
            [useInlineSVG]="true"
            data-testid="icon-sidemenu-data-wizard"
          ></grid-ui-icon>
        }
        @case ('shape-document-library') {
          <grid-ui-icon
            class="SideLinks__icon"
            name="document-library"
            [useInlineSVG]="true"
            data-testid="icon-sidemenu-document-library"
          ></grid-ui-icon>
        }
        @case ('shape-news-and-events') {
          <grid-ui-icon class="SideLinks__icon" name="calendar" [useInlineSVG]="true" data-testid="icon-sidemenu-calendar"></grid-ui-icon>
        }
        @default {
          @if (item.imageHref.endsWith('.svg')) {
            <div class="SideLinks__icon" [innerHTML]="getExtSvg(item.imageHref) | async" data-testid="icon-sidemenu-custom"></div>
          }
        }
      }
    </li>
  }
</ul>
